import { useSettings } from "../../../context";
import { TextareaWrapper, Textarea } from "./styled";

const ContentConfiguration = () => {
  const { updateContentSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    updateContentSettings({ text: newText });
  };

  return (
    <TextareaWrapper>
      <Textarea
        value={currentSettings.content.text}
        onChange={handleContentChange}
        placeholder="Skriv inn tekst"
        rows={3}
      >
        {currentSettings.content.text}
      </Textarea>
    </TextareaWrapper>
  );
};
export default ContentConfiguration;
